import { AppModule } from '@app/types';
import { BreadcrumbItem } from '@mi-front/ui';
import compact from 'lodash/compact';

import { FormattedMessage } from 'react-intl';
import { PageBreadcrumbs } from './PageBreadcrumbs';

export interface PageBreadcrumbsProps {
  readonly module: AppModule;
  readonly items?: readonly BreadcrumbItem[];
  readonly noModuleLink?: boolean;
}

export const ModuleBreadcrumbs = (p: PageBreadcrumbsProps) => {
  return (
    <PageBreadcrumbs
      items={compact([
        {
          content: (
            <>
              {/* {p.module.icon}{' '} */}
              <FormattedMessage id={`${p.module.id}.title`} defaultMessage={p.module.title} />
            </>
          ),
          href: p.noModuleLink ? undefined : `/${p.module.basePath}`,
          active: p.noModuleLink,
        },
        ...p.items!,
      ])}
    />
  );
};

ModuleBreadcrumbs.defaultProps = {
  items: [],
};
